import { lazy } from 'react';

export const LazySafetyFirstPage = lazy(
  () =>
    import(
      /* webpackChunkName: "hellospa--page--safety-first-page" */ './safety-first-page'
    ),
);
